import { useTranslation } from "react-i18next";

export function LinkRequestedPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md mx-auto px-4 w-full">
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-center">
          <div className="text-5xl mb-4 text-green-500">✓</div>
          <h1 className="text-xl font-semibold text-gray-800 mb-3">
            {t("link_requested_title")}
          </h1>
          <p className="text-gray-500 text-sm">
            {t("link_requested_text")}
          </p>
        </div>

        <footer className="mt-10 text-gray-400 text-xs text-center">WLAN-Hilfe</footer>
      </div>
    </div>
  );
}
